import React, { useContext } from 'react'
import { ListOfFacility } from '@s4l/stayforlong/shared/domain/ListOfFacility'
import type { Facility } from '@s4l/stayforlong/shared/domain/Facility'
import { useS4LContext } from '@s4l/react-context'
import MappedIconText from './MappedIconText'
import { PropertyCardContext } from '../../Organisms/PropertyCard/context'
import { FacilityID } from '@s4l/stayforlong/shared/domain/FacilityID'

interface FacilitiesProps {
  facilitiesJSON?: ReturnType<ListOfFacility['toJSON']>
  facilities?: ListOfFacility
  hide?: boolean
  maxFacilities?: number
  size?: 's' | 'l' | 'xl'
}

export const Facilities = ({
  facilitiesJSON,
  facilities,
  hide = false,
  maxFacilities,
  size = 'l',
}: FacilitiesProps) => {
  const { i18n } = useS4LContext()
  const { isSoldOut } = useContext(PropertyCardContext)

  if (!facilitiesJSON && !facilities) return null

  if (hide || isSoldOut) {
    return null
  }

  const listofFacilities = facilities ?? ListOfFacility.fromJSONOrEmpty({ json: facilitiesJSON })

  if (listofFacilities.isEmpty()) {
    return null
  }

  let validFacilities = listofFacilities.uniqueById().filter((facility: Facility) => {
    const translationKey = FacilityID.getTranslationKey(facility.id)
    return !!translationKey
  })

  if (maxFacilities !== undefined) {
    validFacilities = validFacilities.take(maxFacilities)
  }

  if (validFacilities.isEmpty()) {
    return null
  }
  const facilitiesElements = validFacilities.map((facility: Facility) => {
    const translationKey = FacilityID.getTranslationKey(facility.id)!
    // eslint-disable-next-line s4l/require-i18n-formatmessage-id-literal
    const translatedText = facility.name() || i18n.formatMessage({ id: translationKey })

    return (
      <span
        key={facility.id}
        style={{ display: 'inline-block', marginInlineEnd: 'var(--space-8)' }}
      >
        <MappedIconText
          facilityId={facility.id}
          text={translatedText}
          size={size}
          color="var(--color-neutral-600)"
        />
      </span>
    )
  })

  return <>{facilitiesElements}</>
}

Facilities.displayName = 'Facilities'
